var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnfeiteseta(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1183,
    height: 60,
    viewBox: "0 0 1183 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 136,
    y: 22,
    width: 1088,
    height: 16,
    fill: "#181a27"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.8044 30.0208L99.1117 59.5879L115.95 59.5879L90.6675 30.0208L90.844 29.7939L74.0061 29.7939L73.8044 30.0208Z",
    fill: "#181a27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M90.844 29.794L116 0.378096L115.672 -1.44801e-09L99.4646 -7.30688e-08L74.0061 29.794L90.844 29.794Z",
    fill: "#181a27"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9418 29.7939L37.0787 29.7939L36.9022 30.0208L62.2095 59.5879L79.0474 59.5879L53.7401 30.0208L53.9418 29.7939Z",
    fill: "#181a27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9418 29.794L79.0978 0.378096L78.7701 -1.44801e-09L62.5624 -7.30687e-08L37.0787 29.794L53.9418 29.794Z",
    fill: "#181a27"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0395 29.7939L0.176426 29.7939L-2.2882e-05 30.0208L25.282 59.5879L42.1451 59.5879L16.8379 30.0208L17.0395 29.7939Z",
    fill: "#181a27"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0395 29.794L42.1703 0.378096L41.8679 -1.3366e-09L25.6601 -7.29572e-08L0.176442 29.794L17.0395 29.794Z",
    fill: "#181a27"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnfeiteseta);
export default __webpack_public_path__ + "static/media/ENFEITESETA.071facf47cbc5a60b2af49b50361bc57.svg";
export { ForwardRef as ReactComponent };